import { Component, Input } from "@angular/core";

@Component({
  selector: 'corp-spinner',
  standalone: true,
  templateUrl: './corp-spinner.component.html',
})
export class CorpSpinnerComponent {
  /** Taille Tailwind : sm, md, lg, xl (par défaut md) */
  @Input('corp-size') corpSize: 'xs' | 'sm' | 'md' | 'lg' | 'xl' = 'sm';

  /** Couleur Tailwind : text-blue-500, text-red-500, etc. */
  @Input('corp-color') color = 'text-primary-500';

  /** True pour afficher / false pour masquer */
  @Input() active = true;

  /** Portion du cercle visible (0.1 = petit arc, 1 = cercle complet) */
  @Input() percentArc = 0.25;

  get dashArray(): string {
    // Calcule la portion visible du cercle (longueur totale ≈ 126)
    const arc = 126 * this.percentArc;
    return `${arc}, 200`;
  }

  get sizeClass(): string {
    const sizes: Record<string, string> = {
      xs: 'w-2 h-2',
      sm: 'w-4 h-4',
      md: 'w-6 h-6',
      lg: 'w-8 h-8',
      xl: 'w-12 h-12',
    };
    return sizes[this.corpSize] ?? sizes['md'];
  }
}


// import { NgClass } from '@angular/common';
// import { Component, Input } from '@angular/core';

// @Component({
//   selector: 'corp-spinner',
//   standalone: true,
//   templateUrl: 'corp-spinner.component.html',
//   imports:[NgClass],
// })
// export class CorpSpinnerComponent {
//   /** Active ou non le spinner */
//   @Input() active = true;

//   /** Overlay semi-transparent */
//   @Input() overlay = false;

//   /** Couleur du spinner */
//   @Input() color: 'blue' | 'red' | 'green' | 'purple' = 'blue';

//   /** Taille du spinner */
//   @Input() size: 'sm' | 'md' | 'lg' = 'md';

//   get sizeClass(): string {
//     switch (this.size) {
//       case 'sm': return 'w-3 h-3 border-2';
//       case 'lg': return 'w-12 h-12 border-4';
//       case 'md':
//       default: return 'w-8 h-8 border-4';
//     }
//   }

//   get colorClass(): string {
//     switch (this.color) {
//       case 'red': return 'border-red-500';
//       case 'green': return 'border-green-500';
//       case 'purple': return 'border-purple-500';
//       case 'blue':
//       default: return 'border-blue-500';
//     }
//   }

//   /** Le haut du cercle reste transparent pour effet rotation */
//   get borderTopClass(): string {
//     return 'border-t-transparent';
//   }
// }